import { createEpic, createDownloadEpic } from "../helpers";
import {
	updatePlayerSuspendAsyncAction,
	getPlayersAsyncAction,
	updatePlayerTitleAsyncAction,
	exportPlayerDataAsyncAction,
	getPlayerDetailAsyncAction,
	getTournamentsAsyncAction,
} from "./playerActions";

export const getPlayersEpic = createEpic(
	getPlayersAsyncAction,
	"player",
	"getList",
	true
);

export const getPlayerDetailEpic = createEpic(
	getPlayerDetailAsyncAction,
	"player",
	"getPlayerDetail",
	true
);

export const getTournamentsEpic = createEpic(
	getTournamentsAsyncAction,
	"player",
	"getTournaments",
	true
);

export const updatePlayerTitleEpic = createEpic(
	updatePlayerTitleAsyncAction,
	"player",
	"updateTitle",
	true
);

export const updatePlayerSuspendEpic = createEpic(
	updatePlayerSuspendAsyncAction,
	"player",
	"updateSuspend",
	true
);

export const exportPlayersEpic = createDownloadEpic(
	exportPlayerDataAsyncAction,
	"player",
	"exportPlayers",
	true,
	"players"
);
